module.exports = __webpack_public_path__ + "img/default.0279b375.png";